<template>
    <div class="flex flex-col gap-9 pt-8">
        <div class="flex items-center justify-between">
            <div class="shimmer h-10 w-72 rounded" />
            <div class="flex items-center gap-5">
                <div class="shimmer size-[2.125rem] rounded-full" />
                <div class="flex gap-2">
                    <div
                        v-for="i in 3"
                        :key="i"
                        class="shimmer size-2 rounded-full"
                    />
                </div>
                <div class="shimmer size-[2.125rem] rounded-full" />
            </div>
        </div>
        <div class="flex gap-4">
            <div
                v-for="i in 3"
                :key="i"
                class="flex-1 flex flex-col gap-4 border border-categories-border rounded-2xl p-4"
            >
                <div class="shimmer h-8 w-3/5 rounded" />
                <div class="flex flex-wrap gap-2">
                    <div
                        v-for="j in 4"
                        :key="j"
                        class="shimmer h-5 w-20 rounded-4"
                    />
                </div>
                <div class="shimmer w-full aspect-video rounded-lg" />
            </div>
        </div>
    </div>
</template>
